import type { RxJsonSchema } from 'rxdb';
import type { ViewInspector } from './viewInspector.types';

export const viewInspectorSchema: RxJsonSchema<ViewInspector> = {
  type: 'object',
  version: 1,
  description: 'describes work package',
  primaryKey: 'pk_ScheduleLeadFieldInspector',
  properties: {
    pk_ScheduleLeadFieldInspector: { type: 'string', maxLength: 36 },
    workPackageId: { type: 'number' },
    leadInspectorId: { type: ['number', 'null'] },
    fieldInspectorId: { type: ['number', 'null'] },
    clerkId: { type: ['number', 'null'] },
    clerkServiceProviderId: { type: ['number', 'null'] },
    clerkName: { type: ['string', 'null'] },
    fieldInspectorName: { type: ['string', 'null'] },
    isAddedBySP: { type: ['boolean', 'null'] },
    serviceProviderId: { type: ['number', 'null'] },
    organizationName: { type: ['string', 'null'] },
    siteId: { type: ['number', 'null'] },
    disciplineId: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
  },
};
